var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('OTitle',[_vm._v("Spoof Call")]),_c('CShareThisFollow'),_c('CFormFreeDirectCall'),_c('CAdLinkdial'),_c('o-j-l-links'),_c('CShareThisInline'),_c('CFAQDirect'),_c('CAdLinkdial')],1)}
var staticRenderFns = []

export { render, staticRenderFns }